import CantileverButton from 'components/CantileverButton'
import { Pencil } from 'lucide-react'
import React from 'react'
import styled from 'styled-components'

export interface AddCancelSaveButtonsProps {
  saveCancelButtons: boolean
  handleSave: () => void
  handleCancel: () => void
  handleAdd?: () => void
  addButtonText: string
}
export const CancelAndSaveContainer = styled.div`
  display: flex;
  gap: 4px;
  button {
    flex-basis: 0;
    flex-grow: 1;
    flex-shrink: 0;
    padding: 0 0.75rem;
  }
`

export const AddCancelSaveButtons: React.FC<AddCancelSaveButtonsProps> = ({
  saveCancelButtons,
  handleSave,
  handleCancel,
  handleAdd,
  addButtonText,
}) => {
  return (
    <>
      {saveCancelButtons ? (
        <CancelAndSaveContainer>
          <CantileverButton onClick={handleCancel}>Cancel</CantileverButton>
          <CantileverButton primary onClick={handleSave}>
            Save
          </CantileverButton>
        </CancelAndSaveContainer>
      ) : (
        <CantileverButton onClick={handleAdd} style={{ width: '15rem' }}>
          <Pencil width={'1.125rem'} data-testid='edit-button' />{' '}
          {addButtonText}
        </CantileverButton>
      )}
    </>
  )
}
